import { render, staticRenderFns } from "./orgRegistration.vue?vue&type=template&id=44d1f3b4"
import script from "./orgRegistration.vue?vue&type=script&lang=js"
export * from "./orgRegistration.vue?vue&type=script&lang=js"
import style0 from "./orgRegistration.vue?vue&type=style&index=0&id=44d1f3b4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d1f3b4')) {
      api.createRecord('44d1f3b4', component.options)
    } else {
      api.reload('44d1f3b4', component.options)
    }
    module.hot.accept("./orgRegistration.vue?vue&type=template&id=44d1f3b4", function () {
      api.rerender('44d1f3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/setup/components/orgRegistration/orgRegistration.vue"
export default component.exports